import React from "react";
import { GatsbyImage as Image, getImage } from "gatsby-plugin-image";
import { convertToYoutubeEmbed } from "../../utilities/convertUrlToYoutubeEmbed";
import { graphql } from "gatsby";
import CtaButton from "../elements/CtaButton";
import PlayIcon from "../modules/PlayIcon";
import FullScreenVideo from "../modules/FullScreenVideo";
export default function Hero({ data, customClass }) {
  const [videoClicked, setVideoClicked] = React.useState(false);
  const {
    heroText,
    textColor,
    backgroundImage,
    heroSubText,
    callToActionButtonLink,
    callToActionButtonText,
    youtubeEmbedUrl,
  } = data;

  return (
    <section
      className={`Hero hds-container text-white hero h-full ${
        backgroundImage !== null && backgroundImage.video
          ? "full-screen-video"
          : ""
      } ${backgroundImage === null ? "no-bg" : ""}`}
    >
      {backgroundImage !== null && (
        <>
          {backgroundImage.video ? (
            <FullScreenVideo
              mp4={backgroundImage.video.mp4Url}
              image={backgroundImage.video.thumbnailUrl}
              format={backgroundImage.format}
            />
          ) : (
            <div
              className={`${
                youtubeEmbedUrl ? "cursor-pointer h-screen" : "h-full"
              } w-full absolute right-0 inset-y-0 overflow-hidden`}
            >
              <>
                {videoClicked ? (
                  <div className="w-full h-screen">
                    <iframe
                      src={convertToYoutubeEmbed(youtubeEmbedUrl)}
                      className="video__iframe"
                      frameBorder="0"
                      allow="autoplay; encrypted-media"
                      allowFullScreen
                      title="Youtube Video"
                    />
                  </div>
                ) : (
                  <Image
                    className="w-full h-full object-cover object-center image"
                    image={getImage(backgroundImage)}
                    alt={backgroundImage.alt ? backgroundImage.alt : ""}
                    role="img"
                    onClick={() => youtubeEmbedUrl && setVideoClicked(true)}
                    onKeyDown={() => youtubeEmbedUrl && setVideoClicked(true)}
                  />
                )}
              </>
            </div>
          )}
        </>
      )}
      <div
        className={`hds-section hero ${
          backgroundImage === null ? "no-bg" : "image"
        }`}
        style={{
          color: `${textColor !== "white" ? "#333" : textColor}`,
        }}
      >
        {!videoClicked && (
          <div
            className={`${
              youtubeEmbedUrl && "cursor-pointer"
            } hero-copy text-center lg:text-left z-10 lg:pr-sm`}
            onClick={() => youtubeEmbedUrl && setVideoClicked(true)}
            onKeyDown={() => youtubeEmbedUrl && setVideoClicked(true)}
          >
            <div className="flex flex-col items-center">
              <h4
                className={`${`hero-text-${customClass}`} hds-title__large mb-xs font-heading font-bold uppercase text-center`}
              >
                {heroText}
              </h4>
              {heroSubText !== "" && (
                <p
                  className={`text-md relative z-10 text-center hds-copy mb-md`}
                >
                  {heroSubText}
                </p>
              )}
              {callToActionButtonLink &&
                callToActionButtonText &&
                !youtubeEmbedUrl && (
                  <CtaButton
                    link={callToActionButtonLink}
                    text={callToActionButtonText}
                  />
                )}
              {youtubeEmbedUrl && <PlayIcon />}
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

export const heroQuery = graphql`
  fragment HeroComponent on DatoCmsHero {
    internal {
      type
    }
    id
    callToActionButtonLink
    callToActionButtonText
    backgroundImage {
      alt
      format
      gatsbyImageData
      video {
        mp4Url
        thumbnailUrl(format: jpg)
      }
    }
    heroText
    heroSubText
    textColor
    youtubeEmbedUrl
  }
`;
